export default __webpack_public_path__ + "static/media/question.430c1ed7.png";